"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = require("react-jss");

var _DefaultButton = _interopRequireDefault(require("../default/DefaultButton"));

var _withSubmit = _interopRequireDefault(require("./withSubmit"));

var _Loader = _interopRequireDefault(require("../default/Loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A button component to handle form actions, like submit or reset.
 */
const FormButton = (_ref) => {
  let callback = _ref.callback,
      Component = _ref.component,
      reset = _ref.reset,
      loading = _ref.loading,
      LoadingComponent = _ref.loadingComponent,
      suppressErrorMessage = _ref.suppressErrorMessage,
      children = _ref.children,
      submit = _ref.submit,
      otherProps = _objectWithoutProperties(_ref, ["callback", "component", "reset", "loading", "loadingComponent", "suppressErrorMessage", "children", "submit"]);

  return _react.default.createElement(Component, _extends({}, otherProps, {
    onClick: e => submit(e, callback, reset),
    disabled: loading
  }), loading && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(LoadingComponent, null), "\xA0"), children);
};

FormButton.propTypes = {
  callback: _propTypes.default.func,
  loading: _propTypes.default.bool,
  reset: _propTypes.default.bool,
  suppressErrorMessage: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
};
FormButton.defaultProps = {
  component: _DefaultButton.default,
  loadingComponent: _Loader.default
};

var _default = (0, _reactJss.withTheme)((0, _withSubmit.default)(FormButton));

exports.default = _default;